import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaCompany } from "../../../models/api";
import { ProfileCardPlaceholder } from "../../../components/placeholders.component";
import { AppRouteApi, AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { Image } from "../../../components/image.component";
import { Badge } from "rsuite";
import { isBefore } from "date-fns";

type Props = {
  data: ApiSchemaCompany | undefined;
  isValidating: boolean;
};

export const ProfileCard = (props: Props) => {
  const { companyId } = useParams<{ companyId: string }>();
  const getColor = (status: string) =>
    status === "Active"
      ? "#00BDB4"
      : status === "Inactive"
      ? "#FF0000"
      : "#808080";
  return (
    <EditableCard
      className="mb-3"
      title="Company Profile"
      isValidating={props.isValidating}
      link={`${AppRouteUi.Company.Root()}/update/${companyId}`}
      showEditButton
      showBackButton
    >
      {props.isValidating ? (
        <ProfileCardPlaceholder />
      ) : (
        <div className="d-flex align-items-center">
          <div>
            <Image
              src={
                props.data?.companyLogo
                  ? AppRouteApi.Media.ByPath(props.data.companyLogo)
                  : ""
              }
              alt="Profile"
              className="p-3 rounded-circle object-fit-cover"
              width={150}
              height={150}
            />
          </div>
          <div className="ms-5">
            <h1 className="display-6">
              {props.data?.displayName ?? props.data?.name}{" "}
            </h1>
            <Badge
              content={props.data?.status}
              style={{ background: getColor(props.data?.status as string) }}
              className="p-1 px-2 mt-2"
            />
            {!!props.data?.subscription?.subscriptionType && (
              <Badge
                content={
                  isBefore(
                    new Date(props.data?.subscription?.endDate),
                    new Date()
                  )
                    ? "Expired"
                    : props.data?.subscription?.subscriptionType
                }
                className={`p-1 px-2 mt-2 ms-1 bg-${
                  isBefore(
                    new Date(props.data?.subscription?.endDate),
                    new Date()
                  )
                    ? "red"
                    : "green"
                }-200`}
              />
            )}
          </div>
        </div>
      )}
    </EditableCard>
  );
};
